import ROUTES from './paths'
import PAGE_TITLES from './titles'

export interface LinkProps {
  label: string
  link: string
}

export interface MenuItemProps {
  group?: string
  links: LinkProps[]
}

export const adminMobileMenuList: MenuItemProps[] = [
  {
    group: 'People',
    links: [
      {
        label: PAGE_TITLES.FACULTY_AND_STAFF,
        link: ROUTES.FACULTY_AND_STAFF
      },
      {
        label: PAGE_TITLES.STUDENTS,
        link: ROUTES.STUDENTS
      }
    ]
  },
  {
    group: 'Reporting',
    links: [
      {
        label: PAGE_TITLES.REPORTING_HIERARCHY,
        link: ROUTES.REPORTING_HIERARCHY
      },
      {
        label: PAGE_TITLES.ACADEMIC_UNITS,
        link: ROUTES.ACADEMIC_UNITS
      },
      {
        label: PAGE_TITLES.COURSE_CATALOG,
        link: ROUTES.COURSE_CATALOG
      },
      {
        label: PAGE_TITLES.ATTRIBUTES,
        link: ROUTES.ATTRIBUTES
      },
      {
        label: PAGE_TITLES.TERMS,
        link: ROUTES.TERMS
      }
    ]
  },
  {
    group: 'Surveys',
    links: [
      {
        label: 'Templates',
        link: ROUTES.SURVEYS
      },
      {
        label: PAGE_TITLES.DISTRIBUTION_SERIES,
        link: ROUTES.DISTRIBUTION_SERIES
      }
    ]
  },
  {
    group: 'Other',
    links: [
      {
        label: 'Integrations',
        link: ROUTES.INTEGRATIONS
      },

      {
        label: PAGE_TITLES.TASKS,
        link: ROUTES.TASKS
      }
    ]
  }
]

export const adminSettingsMenuList: MenuItemProps[] = [
  {
    group: 'INSTITUTION',
    links: [
      {
        label: PAGE_TITLES.REPORTING_HIERARCHY,
        link: ROUTES.REPORTING_HIERARCHY
      },
      {
        label: PAGE_TITLES.ACADEMIC_UNITS,
        link: ROUTES.ACADEMIC_UNITS
      }
    ]
  },
  {
    group: 'DATA ENHANCEMENT',
    links: [
      {
        label: 'Integrations',
        link: ROUTES.INTEGRATIONS
      },
      {
        label: PAGE_TITLES.ATTRIBUTES,
        link: ROUTES.ATTRIBUTES
      }
    ]
  },
  {
    group: 'OTHER',
    links: [
      {
        label: PAGE_TITLES.TASKS,
        link: ROUTES.TASKS
      }
    ]
  }
]

export const adminSurveySetupMenuList: MenuItemProps[] = [
  {
    group: 'SURVEY DISTRIBUTION',
    links: [
      {
        label: PAGE_TITLES.DISTRIBUTION_SERIES,
        link: ROUTES.DISTRIBUTION_SERIES
      },
      {
        label: PAGE_TITLES.MY_SURVEYS,
        link: ROUTES.SURVEYS
      }
    ]
  },
  {
    group: 'TERM SETUP',
    links: [
      {
        label: PAGE_TITLES.TERMS,
        link: ROUTES.TERMS
      },
      {
        label: PAGE_TITLES.COURSE_CATALOG,
        link: ROUTES.COURSE_CATALOG
      },
      {
        label: PAGE_TITLES.PEOPLE,
        link: ROUTES.FACULTY_AND_STAFF
      }
    ]
  }
]
